import InitVue from "../vue/initvue";
import Accordion from "common/js/script/accordion";
import Video from "common/js/script/video";
import Utbildning from "./utbildning";
import Bilder from "common/js/script/bilder";
import Karusell from "./karusell";

export default {
  observe: function () {
    // Observe attribute on body for changes so that we can reinitiate script
    // components when the contents is loaded through any of the menus
    const body = document.querySelector("body");
    const config = {
      attributes: true,
      attributeFilter: ["data-observe-update"],
      childList: false,
      subtree: false,
    };

    // Callback function to execute when mutations are observed
    const callback = function (mutationsList, observer) {
      // Use traditional 'for loops' for IE 11
      for (const mutation of mutationsList) {
        if (mutation.type === "attributes") {
          let foldable = document.querySelectorAll("p.foldable");
          if (foldable.length) {
            Accordion.initAccordion();
          }

          let videos = document.querySelectorAll(".videolink");
          if (videos.length) {
            Video.initVideo();
          }

          let bilder = document.querySelectorAll(
            ".qbankmediawrapper .bildText"
          );
          if (bilder.length) {
            Bilder.initBilder();
          }

          let karusell = document.querySelectorAll(".karusellblock");
          if (karusell.length) {
            Karusell.initKarusell();
          }

          let sidebarMenu = document.getElementById("sidebar-menu-vue");
          if (sidebarMenu && !sidebarMenu.hasAttribute("data-v-app")) {
            InitVue.deleteOldComponent("sidebar-menu-vue");
            InitVue.initComponent("#sidebar-menu-vue");
          }

          let tillfalleskarusell =
            document.getElementById("tillfalleskarusell");
          if (tillfalleskarusell) {
            Utbildning.initUtbildning();
          }

          let anmalningsknappar = document.querySelectorAll(
            ".anmalningsknapp-vue"
          );

          if (anmalningsknappar.length) {
            var oinitierad = 0;
            anmalningsknappar.forEach((knapp) => {
              if (!knapp.hasAttribute("data-v-app")) {
                InitVue.deleteOldComponent("anmalningsknapp-vue");
                oinitierad++;
              }
            });

            if (oinitierad > 0) {
              InitVue.initComponent(".anmalningsknapp-vue");
            }
          }

          let sitesearch = document.getElementById("sitesearch-vue");
          if (sitesearch && !sitesearch.hasAttribute("data-v-app")) {
            InitVue.deleteOldComponent("sitesearch-vue");
            InitVue.initComponent("#sitesearch-vue");
          }

          let galleri = document.getElementById("galleri-vue");
          if (galleri && !galleri.hasAttribute("data-v-app")) {
            InitVue.deleteOldComponent("galleri-vue");
            InitVue.initComponent("#galleri-vue");
          }

          observeComponent("rssreader-vue");
          observeComponent("listblock-vue");
          observeComponent("divalistblock");
          observeComponent("artikellistblock");
        }
      }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(body, config);

    // Later, you can stop observing
    //observer.disconnect();
  },
};

function observeComponent(className) {
  let components = document.querySelectorAll(`.${className}`);
  if (components.length) {
    var oinitierad = 0;
    components.forEach((comp) => {
      if (!comp.hasAttribute("data-v-app")) {
        InitVue.deleteOldComponent(className);
        oinitierad++;
      }
    });

    if (oinitierad > 0) {
      InitVue.initComponent(`.${className}`);
    }
  }
}
